import React from 'react';
import { FlatList, Image } from 'react-native';
import type { FundingRequestProps, PublicPlayerProps } from "../../types"
import moment from 'moment-mini';
import { Button, Text, View } from '../../Components/Themed';

type FundingRequestListProps = {
    funding_requests:FundingRequestProps[],
    players:PublicPlayerProps[],
    onApproveRequest:(funding_request_id:string) => void,
    onDeclineRequest:(funding_request_id:string) => void
}
const FundingRequestList = ({ funding_requests, players, onApproveRequest, onDeclineRequest }:FundingRequestListProps) => {

    const renderFundingRequests = (data:{ item:FundingRequestProps, index:number }) => {
        const player = players.find(p => p.player_id == data.item.player_id)
        if(!player){ return <></> }
        return (
            <View style={{ flexDirection:'row', alignItems:'center' }}>
                <Image
                    source={{ uri: player.profile_pic && player.profile_pic != '' ? player.profile_pic : 'https://res.cloudinary.com/hoabts6mc/image/upload/v1722453927/default_man_n96ofq.webp' }}
                    style={{ height:40, width:40, borderRadius:100 }}
                    resizeMode='cover'
                />
                <View style={{ flex:1, marginLeft:10 }}>
                    <Text size={14} theme='h1'>{player.first_name} {player.last_name}</Text>
                    <Text style={{ marginTop:3 }} size={12} theme='description'>Requested on {moment(data.item.create_datetime).format('MMM DD hh:mm a')}</Text>
                </View>
                <Text size={14} weight='bold' theme='h1'>${data.item.amount.toFixed(2)}</Text>
                <Button
                    title='DECLINE'
                    style={{ marginRight:5, marginLeft:5 }}
                    type='error'
                    onPress={() => onDeclineRequest(data.item.funding_request_id)}
                />
                <Button
                    title='APPROVE'
                    type='success'
                    onPress={() => onApproveRequest(data.item.funding_request_id)}
                />
            </View>
        )
    }

    return (
        <View>
            <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:10}}>
                <View transparent style={{ flex:1 }}>
                    <Text theme='h1'>Funding Requests</Text>
                    <Text style={{ marginTop:3 }} theme='description'>Below are the pending funding requests.  Approve or decline them.</Text>
                </View>
            </View>
            <View transparent>
                <FlatList
                    key={'funding_requests'}
                    data={funding_requests}
                    keyExtractor={(item) => item.funding_request_id.toString()}
                    renderItem={renderFundingRequests}
                />
            </View>
        </View>
    )
}

export default FundingRequestList